var JSONRpcError = /** @class */ (function () {
    function JSONRpcError(code, message) {
        this.code = code;
        this.message = message;
    }
    return JSONRpcError;
}());
export { JSONRpcError };
export var JSONRPC;
(function (JSONRPC) {
    /**
     *
     *
     * @export
     * @enum {number}
     */
    var EVENT_LIST;
    (function (EVENT_LIST) {
        EVENT_LIST["REQUEST"] = "RPC_request";
        EVENT_LIST["RESPONSE"] = "RPC_response";
        EVENT_LIST["EVENT"] = "RPC_event";
        EVENT_LIST["MOUNT"] = "RPC_mount";
    })(EVENT_LIST = JSONRPC.EVENT_LIST || (JSONRPC.EVENT_LIST = {}));
})(JSONRPC || (JSONRPC = {}));
